import template from './displayInfo.html';
import './displayInfo.scss';

export const DisplayInfo = angular
    .module('checkout.components.displayInfo', [])
    .component('displayInfo', {
        template,
        transclude: {
            title: '?displayInfoTitle',
            content: 'displayInfoContent',
            verified: '?displayInfoVerified'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/displayInfo/displayInfo.js